import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ClientCoreModule } from '@thehubz/client/core';
import { ApiModule } from '@thehubz/client/data-access-api';
import { AnonymousAuthInterceptor } from './anonymous-auth-interceptor';
import { AnonymousAuthService } from './anonymous-auth.service';

@NgModule({
  imports: [CommonModule, ClientCoreModule, ApiModule],
  providers: [AnonymousAuthService, { provide: HTTP_INTERCEPTORS, useClass: AnonymousAuthInterceptor, multi: true }],
})
export class ClientAnonymousAuthModule {}
